export const assetAt = url => jsRoutes.controllers.Assets.versioned(url).url;

export const defaultThumbnail = () => assetAt('images/placeholder.png');



// WEBPACK FOOTER //
// ./src/utils/assets.js